import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { RootState } from "../../../../globals";
import useEsTelefono from "../../../../utils/esTelefono";
import { ScheduleCatalogService } from "../../../../services/v2/scheduleCatalog.service";
import logoHorizontal from "../../../../assets/images/wa-horizontal-color.png";
import { montarCatalogo } from "./catalogoHorarios";
import OfertaAcademica from "./ofertaAcademica";
import "./catalogoHorarios.css";

const servicio = new ScheduleCatalogService();

// Dos pantallas en la misma sección (Esteban, 2026-10-27): Oferta y Catálogo de Horarios. Quien ve una ve la otra.
type Vista = "oferta" | "horarios";
const VISTA_GUARDADA = "wapp.scheduleCatalog.vista";

function vistaInicial(): Vista {
	const deLaLiga = new URLSearchParams(window.location.search).get("vista");
	if (deLaLiga === "oferta" || deLaLiga === "horarios") {
		return deLaLiga;
	}
	try {
		return localStorage.getItem(VISTA_GUARDADA) === "horarios" ? "horarios" : "oferta";
	} catch (e) {
		return "oferta";
	}
}

/**
 * Catálogo de Horarios (Academia): la misma pantalla de horarios.washingtonacademy.com.
 * Todo el catálogo lo pinta catalogoHorarios.ts (copia del sitio); aquí solo se le da dónde
 * vivir, de dónde sacar los datos y en qué plantel abrir.
 */
const ScheduleCatalogController: React.FC = () => {
	const movil = useEsTelefono();
	const sessionCampus: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampus);
	const legacyCampusKey: any = useSelector((state: RootState) => state.currentUserCampus.value);
	const legacyCampusRef: any = useSelector((state: RootState) => state.campusRef.value);
	const legacyCampus: any = legacyCampusKey && legacyCampusRef ? legacyCampusRef[legacyCampusKey] : null;
	//El plantel de la barra manda; el de la sesión solo si no hay barra (2026-09-24).
	const campusId: number | null = legacyCampus?.id ?? sessionCampus?.id ?? null;
	const lienzo = useRef<HTMLDivElement>(null);
	const [vista, setVista] = useState<Vista>(vistaInicial);

	const cambiar = (v: Vista) => {
		setVista(v);
		try {
			localStorage.setItem(VISTA_GUARDADA, v);
		} catch (e) {
			// sin almacenamiento: solo no se recuerda
		}
	};

	useEffect(() => {
		if (vista !== "horarios" || campusId === null || lienzo.current === null) {
			return;
		}
		return montarCatalogo(lienzo.current, {
			cargar: () => servicio.catalogue(campusId).then((r) => r.data),
			registrarCopia: (datos: any) => { servicio.logCopy(campusId, datos).catch(() => undefined); },
			plantelInicial: campusId,
			logo: logoHorizontal
		});
	}, [campusId, vista]);

	if (campusId === null) {
		return <React.Fragment />;
	}
	return (
		<div className="container-fluid waModulo" style={{ textAlign: "left", padding: movil ? "10px 12px 0 12px" : "10px 24px 0 24px" }}>
			<div className="waOfertaPestanas" role="tablist">
				<button type="button" role="tab" aria-selected={vista === "oferta"} className={vista === "oferta" ? "activa" : ""} onClick={() => cambiar("oferta")}>Oferta</button>
				<button type="button" role="tab" aria-selected={vista === "horarios"} className={vista === "horarios" ? "activa" : ""} onClick={() => cambiar("horarios")}>Catálogo de Horarios</button>
			</div>
			{vista === "oferta" ? <OfertaAcademica campusId={campusId} logo={logoHorizontal} /> : <div className="waCatalogoHorarios" ref={lienzo} />}
		</div>
	);
};

export default ScheduleCatalogController;
